angular.module('kareo.ui.shared.modules.erx-wizard', ['kareo.ui.shared.modules.iframe-modal-service'])
.service "ErxWizard", ['IFrameModalService', (IFrameModalService) ->
  open = ->
    IFrameModalService.open('/EhrWebApp/credentialing/wizard')

  open: open

]

